import { AfterViewChecked, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { fuseAnimations } from '@fuse/animations';
import { BaseService } from 'app/_helpers/base/base.service';
import { TranslateService } from '@ngx-translate/core';
import { reverse, forEach, find, cloneDeep } from 'lodash';
import { MatDialog } from '@angular/material/dialog';
import { AuthenticationService } from 'app/services';
import { GlobalFuntions } from 'app/_helpers';
import { Subject } from 'rxjs';
import { FiltersComponent } from '../../filters/filters.component';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-wg-accounts-statistics',
  templateUrl: './wg-accounts-statistics.component.html',
  styleUrls: ['./wg-accounts-statistics.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations
})
export class WgAccountsStatisticsComponent implements OnInit, OnDestroy, AfterViewChecked {

  widget5: any;
  widgets = {} as any;
  months = [] as any;
  days = [] as any;
  loadData = false as boolean;
  searchDialogRef: any;
  user: any;
  filter = {} as any;

  private _unsubscribeAll: Subject<any>;

  constructor(
    private _gService: BaseService,
    private _translateService: TranslateService,
    private _matDialog: MatDialog,
    private _authenticationService: AuthenticationService,
    private cdref: ChangeDetectorRef,
    private _globalFunctions: GlobalFuntions
  ) {
    this.widget5 = {
      currentRange: 'TW',
      gradient: false,
      legend: false,
      showLabels: true,
      animations: true,
      xAxis: true,
      yAxis: true,
      showYAxisLabel: true,
      showXAxisLabel: true,
      xAxisLabel: this._translateService.instant('days'),
      yAxisLabel: this._translateService.instant('accounts'),
      timeline: true,
      roundDomains: true,
      showGridLines: true,
      scheme: {
        domain: ['#5AA454', '#E44D25', '#CFC0BB', '#7aa3e5', '#a8385d', '#aae3f5']
      },

      onSelect: (ev) => {
        console.log(ev);
      },
      supporting: {
        currentRange: '',
        xAxis: false,
        yAxis: false,
        gradient: true,
        legend: false,
        showLabels: true,
        isDoughnut: true,
        view: [700, 400],

        scheme: {
          domain: ['#5AA454', '#E44D25', '#CFC0BB', '#7aa3e5', '#a8385d', '#aae3f5']
        }
      }
    };
    this.user = this._authenticationService.currentUserValue;
    if (this.user.user_role === 'agency_manager' && !this.user.user_office_data.master_office) {
      this.filter = { offices: [this.user.user_office_id] };
    } else if (this.user.user_role === 'agent' || this.user.user_role === 'agent_medium' || this.user.user_role === 'admin_agent_light') {
      this.filter = { users: [this.user._id] };
    }
    this._unsubscribeAll = new Subject();
  }

  ngOnInit(): void {

    this.getAccounts('TW', this.filter);

    this.widgets = {
      widget5: {
        title: this._translateService.instant('Accounts statistics'),
        ranges: {
          TW: this._translateService.instant('this_week'),
          SM: this._translateService.instant('last_6_months'),
          TY: this._translateService.instant('this_year'),
        },
        mainChart: { TY: [], SM: [], TW: [] },
        supporting: { TY: [], SM: [], TW: [] }
      }
    };
  }

  getAccounts(range: any, filter: any): void {
    this.loadData = true;
    this.setMonths(range);
    this._gService.post(`dashboard/accounts_statistics?range=${range}`, filter, 'nodejs').subscribe((data: any) => {
      this.setlineChart(cloneDeep(data.data));
      if (data.pieChart && data.pieChart.length) {
        this.setPieChart(cloneDeep(data.pieChart));
      }
    });
  }

  setPieChart(data: any): void {
    if (data.length) {
      forEach(data, (value) => {
        value.name = value.name ? this._translateService.instant(value.name) : '';
      });
    }
    this.widgets.widget5.supporting[this.widget5.currentRange] = data;
  }

  setlineChart(data: any): void {
    this.widgets.widget5.mainChart[this.widget5.currentRange] = [];
    let i = 0;
    let temp;
    const clientData = {} as any;
    clientData.series = [];
    const inactiveData = {} as any;
    inactiveData.series = [];
    const leadData = {} as any;
    leadData.series = [];
    const previousData = {} as any;
    previousData.series = [];
    const prospectData = {} as any;
    prospectData.series = [];
    clientData.name = this._translateService.instant('client');
    inactiveData.name = this._translateService.instant('inactive');
    leadData.name = this._translateService.instant('lead');
    previousData.name = this._translateService.instant('previous client');
    prospectData.name = this._translateService.instant('prospect');
    forEach(data, (value) => {
      temp = find(value, ['name', 'client']);
      temp.name = this.widget5.currentRange === 'TW' ? this.days[i] : this.months[i];
      if (temp.name) {
        clientData.series.push(temp);
      }

      temp = find(value, ['name', 'inactive']);
      temp.name = this.widget5.currentRange === 'TW' ? this.days[i] : this.months[i];
      if (temp.name) {
        inactiveData.series.push(temp);
      }

      temp = find(value, ['name', 'lead']);
      temp.name = this.widget5.currentRange === 'TW' ? this.days[i] : this.months[i];
      if (temp.name) {
        leadData.series.push(temp);
      }

      temp = find(value, ['name', 'previous client']);
      temp.name = this.widget5.currentRange === 'TW' ? this.days[i] : this.months[i];
      if (temp.name) {
        previousData.series.push(temp);
      }

      temp = find(value, ['name', 'prospect']);
      temp.name = this.widget5.currentRange === 'TW' ? this.days[i] : this.months[i];
      if (temp.name) {
        prospectData.series.push(temp);
      }

      i++;
    });
    this.widgets.widget5.mainChart[this.widget5.currentRange].push(clientData);
    this.widgets.widget5.mainChart[this.widget5.currentRange].push(inactiveData);
    this.widgets.widget5.mainChart[this.widget5.currentRange].push(leadData);
    this.widgets.widget5.mainChart[this.widget5.currentRange].push(previousData);
    this.widgets.widget5.mainChart[this.widget5.currentRange].push(prospectData);
    this.loadData = false;
  }

  setMonths(range: any): void {
    this.months = [];
    this.days = [];
    const date = new Date();
    let day = date.getDay() + 1;
    let month = date.getMonth() + 2;
    if (range === 'SM' || range === 'TY') {
      this.widget5.xAxisLabel = this._translateService.instant('months');
      for (let i = 0; i < 12; i++) {
        if (month === 1) {
          month = 12;
        } else {
          month--;
        }
        if (range === 'SM' && i === 6) {
          break;
        }
        this.months.push(this._globalFunctions.getMonths(month));
      }
      reverse(this.months);
    } else {
      this.widget5.xAxisLabel = this._translateService.instant('days');
      for (let i = 0; i < 7; i++) {
        this.days.push(this._globalFunctions.getDays(day));
        if (day === 0) {
          day = 6;
        } else {
          day--;
        }
      }
      reverse(this.days);
    }
  }

  openFilterModal(): void {
    this.searchDialogRef = this._matDialog.open(FiltersComponent, {
      panelClass: 'event-form-dialog',
      data: 'userOffice',
    });
    this.searchDialogRef.afterClosed()
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((response: any) => {
        if (response) {
          this.filter = {};
          this.filter = response;
          this.getAccounts(this.widget5.currentRange, this.filter);
        }
      });
  }

  ngAfterViewChecked(): void {
    this.cdref.detectChanges();
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

}
